import { createQueryKeys } from '@lukemorales/query-key-factory';
import { useMutation, useQuery } from '@tanstack/react-query';
import InquiryFileApi from 'api/methods/InquiryFileApi';
import type { InquiryFile } from 'api/methods/InquiryFileApi';

/**
 * [InquiryFile] Query Key 생성
 * --
 */
export const inquiryFileQueryKeys = createQueryKeys('inquiryfile', {
  getInquiryFile: (
    idx: number,
    params?: { [key: string]: string | number }
  ) => [idx, params],
  getInquiryFiles: (params?: { [key: string]: string | number }) => [params],
});

/**
 * [InquiryFile] 문의 파일 전체 조회
 * --
 */
export const useGetInquiryFiles = (params?: {
  [key: string]: string | number;
}) => {
  const data = useQuery({
    queryKey: inquiryFileQueryKeys.getInquiryFiles(params).queryKey,
    queryFn: () => InquiryFileApi.getInquiryFiles(params),
  });

  return data;
};

/**
 * [InquiryFile] 문의 파일 상세 조회
 * --
 */
export const useGetInquiryFile = (
  idx: number,
  params?: { [key: string]: string | number }
) => {
  const data = useQuery({
    queryKey: inquiryFileQueryKeys.getInquiryFile(idx, params).queryKey,
    queryFn: () => InquiryFileApi.getInquiryFile(idx, params),
  });

  return data;
};

/**
 * [InquiryFile] 문의 파일 생성
 * --
 */
export const useCreateInquiryFile = (body: InquiryFile) => {
  const { mutateAsync: createInquiryFile, ...result } = useMutation({
    mutationFn: (variables: InquiryFile) =>
      InquiryFileApi.createInquiryFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { createInquiryFile, ...result };
};

/**
 * [InquiryFile] 문의 파일 수정
 * --
 */
export const useUpdateInquiryFile = (body: InquiryFile) => {
  const { mutateAsync: updateInquiryFile, ...result } = useMutation({
    mutationFn: (variables: InquiryFile) =>
      InquiryFileApi.createInquiryFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { updateInquiryFile, ...result };
};

/**
 * [InquiryFile] 문의 파일 삭제
 * --
 */
export const useDeleteInquiryFile = (idx: number) => {
  const { mutateAsync: deleteInquiryFile, ...result } = useMutation({
    mutationFn: (variables: number) =>
      InquiryFileApi.deleteInquiryFile(variables),
    onSuccess: (data, variables) => {
      console.log(data, variables);
    },
    onError: (error) => {
      console.error(error);
    },
  });

  return { deleteInquiryFile, ...result };
};

/**
 * [InquiryFile] 문의 파일 Bulk 생성
 * --
 */
export const useBulkCreateInquiryFile = () => {
  const { mutateAsync: bulkCreateInquiryFile, ...result } = useMutation({
    mutationFn: (variables: InquiryFile[]) =>
      InquiryFileApi.bulkCreateInquiryFile(variables),
  });

  return { bulkCreateInquiryFile, ...result };
};
